import { capitalizeAllIfLower, formatDate } from '@btime/helpers'
import { compose, path, prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { FlexCol } from '../../../components/structure/FlexGrid'
import { RefetchingIndicator } from '../../../components/helpers/StatePresenter'
import { SmallText, Title } from '../../../packages/kiti/components/presentation/Text'
import { UserAvatar } from '../../../components/presentation/Avatar'
import { useUserActionsList } from '../../../utils/actions/users/list'
import { useUserFastActionsList } from '../../../utils/actions/users/fastList'
import DeletedTag from '../../../components/helpers/DeletedTag'
import DropdownLink from '../../../components/navigation/DropdownLink'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import IconText from '../../../packages/kiti/components/presentation/IconText'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import { useContract } from './_load/ContractLoader'

const ModalHeader = () => {
  const contract = useContract()
  const { t } = useTranslation('common')
  const options = useUserActionsList(contract.user, null, { hide: ['seeDetails'] })

  const title = compose(capitalizeAllIfLower, prop('name'))(contract.user)
  const createdAt = compose(formatDate('DD/MM/YYYY HH:mm'), path(['contract', 'insertedAt']))(contract.user)

  const fastActions = useUserFastActionsList(contract.user)

  return (
    <>
      <Grid justify="flex-start" align="center" gutter={0.3}>
        <UserAvatar user={contract.user} size="normal" />
        <Col flex={1}>
          <Title size="h4" color="dark1" noMargin>
            {title}
          </Title>
          <SmallText color="dark3">
            {t('createdAt')} {createdAt}
          </SmallText>
        </Col>
        <Col flex={1}></Col>

        <Col>
          <DeletedTag entity={contract} />
        </Col>
        <Col>
          <RefetchingIndicator />
        </Col>

        {!contract.deleted && (
          <>
            {fastActions.map(action => (
              <>
                <FlexCol key={action.label}>
                  <IconText iconLeft={action.icon} color="dark3" bold {...action} noWrap />
                </FlexCol>
                <Separator vertical />
              </>
            ))}
            <Col>
              <DropdownLink
                fromRight
                options={options}
                actionContent={<Icon name="BsThreeDotsVertical" size={1.4} />}
                t={t}
              />
            </Col>
          </>
        )}
      </Grid>

      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
